import { render, staticRenderFns } from "./QRPopup.vue?vue&type=template&id=4804dcaa"
import script from "./QRPopup.vue?vue&type=script&lang=js"
export * from "./QRPopup.vue?vue&type=script&lang=js"
import style0 from "./QRPopup.vue?vue&type=style&index=0&id=4804dcaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports